export const menuItems = [
  {
    title: 'Marketing',
    path: 'Marketing',
    cName: 'dropdown-link',
  },
  {
    title: 'Consulting',
    path: 'Consulting',
    cName: 'dropdown-link',
  },
  {
    title: 'Design',
    path: 'Design',
    cName: 'dropdown-link',
  },
  {
    title: 'Development',
    path: 'Development',
    cName: 'dropdown-link',
  },
];

export const navbar = [
  {
    title: 'Homeoffice',
    path: 'https://www.sipgate.de/homeoffice',
  },
  {
    title: 'Produkte',
    path: 'https://www.sipgate.de/produkte',
  },
  {
    title: 'Über uns',
    path: 'https://www.sipgate.de/wir-sind-sipgate',
  },
  {
    title: 'Jobs',
    path: 'https://www.sipgate.de/jobs',
  },
  {
    title: 'Besuch',
    path: 'https://www.sipgate.de/besuch',
  },
  {
    title: 'Blog',
    path: 'https://www.sipgate.de/blog',
  },
];
